module.exports = __webpack_public_path__ + "img/logo_paladin_login@2x.a4f12c5e.png";